var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpArrowPlum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 6.293a1 1 0 00-1.414 0l-6.364 6.364a1 1 0 001.414 1.414L16 8.414l5.657 5.657a1 1 0 001.414-1.414l-6.364-6.364zM17 27V7h-2v20h2z",
    fill: "#31347a"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTYuNzA3MSA2LjI5Mjg5QzE2LjMxNjYgNS45MDIzNyAxNS42ODM0IDUuOTAyMzcgMTUuMjkyOSA2LjI5Mjg5TDguOTI4OTMgMTIuNjU2OUM4LjUzODQxIDEzLjA0NzQgOC41Mzg0MSAxMy42ODA1IDguOTI4OTMgMTQuMDcxMUM5LjMxOTQ2IDE0LjQ2MTYgOS45NTI2MiAxNC40NjE2IDEwLjM0MzEgMTQuMDcxMUwxNiA4LjQxNDIxTDIxLjY1NjkgMTQuMDcxMUMyMi4wNDc0IDE0LjQ2MTYgMjIuNjgwNSAxNC40NjE2IDIzLjA3MTEgMTQuMDcxMUMyMy40NjE2IDEzLjY4MDUgMjMuNDYxNiAxMy4wNDc0IDIzLjA3MTEgMTIuNjU2OUwxNi43MDcxIDYuMjkyODlaTTE3IDI3TDE3IDdMMTUgN0wxNSAyN0wxNyAyN1oiIGZpbGw9IiMzMTM0N2EiLz4KPC9zdmc+Cgo=";
export { SvgUpArrowPlum as ReactComponent };